import { Base } from '@studiometa/js-toolkit';

/**
 * FollowCursor
 *
 * Affiche un curseur custom (ref "cursor") qui suit la souris à l'intérieur de
 * l'élément hôte, en restant entièrement contenu dans ses limites.
 */
export default class FollowCursor extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'FollowCursor',
    refs: ['cursor'],
  };

  /**
   * Show the cursor on enter.
   */
  onMouseenter() {
    this.$refs.cursor.style.opacity = '1';
  }

  /**
   * Hide the cursor on leave.
   */
  onMouseleave() {
    this.$refs.cursor.style.opacity = '0';
  }

  /**
   * Move the cursor, clamped so the whole circle stays inside the host.
   * @param {{ event: MouseEvent }} options
   */
  onMousemove({ event }) {
    const { cursor } = this.$refs;
    const rect = this.$el.getBoundingClientRect();
    const radius = cursor.offsetWidth / 2;

    let x = event.clientX - rect.left;
    let y = event.clientY - rect.top;

    x = Math.max(radius, Math.min(x, rect.width - radius));
    y = Math.max(radius, Math.min(y, rect.height - radius));

    cursor.style.transform = `translate(${x - radius}px, ${y - radius}px)`;
  }
}
